import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { FormSelectComponent } from '../form-select/form-select.component';
import { PaginationInterface, SelectOptionsInterface } from '../../types';
import { UnsubscribeBase } from '@core-utils';
import { TranslocoDirective } from '@jsverse/transloco';
import { uiKitScope } from '../../constants/ui-constant';
import { provideUiKitScope } from '../../providers';

@Component({
  selector: 'ui-form-pagination',
  imports: [NgbPagination, FormSelectComponent, TranslocoDirective],
  templateUrl: './form-pagination.component.html',
  styleUrl: './form-pagination.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
})
export class FormPaginationComponent extends UnsubscribeBase {
  collectionSize = input.required<number>();
  pageSize = model.required<number>();
  page = model.required<number>();
  paginationValue = output<PaginationInterface>();
  pageSizeList: SelectOptionsInterface[] = [
    { id: 5, name: '5' },
    { id: 10, name: '10' },
    { id: 15, name: '15' },
    { id: 20, name: '20' },
  ];

  onPageChange(page: number) {
    this.page.set(page);
    this.emitPaginationValue();
  }

  changePageSize(pageSize: number) {
    this.pageSize.set(pageSize);
    this.page.set(1);
    this.emitPaginationValue();
  }

  private emitPaginationValue() {
    this.paginationValue.emit({ limit: this.pageSize(), page: this.page() });
  }

  protected readonly uiKitScope = uiKitScope;
}
